import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Totes_ds_get_first_available_tote_for_inductionService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: {  }): 
  Promise<{ result: { Id?: number, ContainerTypeId?: number, PlcInstructions?: string, ToteContainerId?: number, Type?: { Description?: string, Name?: string }, ToteContainer?: { Id?: number, ContainerTypeId?: number, LookupCode?: string, Status?: { Name?: string } }, TaskLookups?: { ToteGroupingId?: number, TaskId?: number, Task?: { ExpectedSourceLocationId?: number } }[] } }> 
  {
    let $url = `${environment.backendUrl}api/Totes/datasources/ds_get_first_available_tote_for_induction/get`;
    
    const $options = {
    }
    
    const $body = null;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      }) {
      return false;
    }
}
